import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import BonusExpenditure from 'features/BonusExpenditure';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function BonusExpenditureViewList() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="bonus_expenditure">
            <BonusExpenditure />
          </Can>
          <Can not do="read" on="bonus_expenditure">
            <h4 className="text-red-500">{t('permission.forbid.read.bonusExpenditure')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default BonusExpenditureViewList;
